import React, { useEffect, useRef, useState } from "react";
import style from "./PlanTemplateItem.module.sass";
import { callApi } from "../../../helpers";

function PlanTemplateItem(props) {
  const {
    name,
    planTemplates,
    onClickPhase,
    openItemName,
    setOpenItemName,
  } = props;


  const [error, setError] = useState(null);
  const [selectedPlanTemplate, setSelectedPlanTemplate] = useState(null);
  const [statusSlider, setStatusSlider] = useState("close");

  useEffect(() => {
    if (openItemName !== name && statusSlider === "open") {
      setStatusSlider("close");
      setSelectedPlanTemplate(null);
    }
  }, [openItemName]);

  const retrievePlanTemplate = (url) => {
    callApi(
      url, "GET", 'json',
      (response) => {
        console.log("submitForm response", response);
        setSelectedPlanTemplate(response);
        setStatusSlider("open");
        onClickPhase(response.urls.createPlan);
      },
    );
  }

  const toggleDetails = (planTemplate) => {
    const isSameItem = openItemName === name;
    const isSamePhase = selectedPlanTemplate?.id === planTemplate.id;

    // Caso: clicco la stessa fase già aperta => chiudo
    if (isSameItem && isSamePhase) {
      setStatusSlider("close");
      setSelectedPlanTemplate(null);
      setOpenItemName(null);
      onClickPhase(null); // reset URL
      return;
    }

    // Caso: clicco una fase diversa nello stesso item
    if (isSameItem && !isSamePhase) {
      setStatusSlider("loading");
      try {
        retrievePlanTemplate(planTemplate.planTemplateUrl);
        // setOpenItemName(name); // già settato
      } catch (err) {
        setStatusSlider("error");
        setError(err);
      }
      return;
    }

    // Caso: clicco un item diverso da quello aperto
    if (!isSameItem) {
      setStatusSlider("loading");
      try {
        retrievePlanTemplate(planTemplate.planTemplateUrl);
        setOpenItemName(name);
      } catch (err) {
        setStatusSlider("error");
        setError(err);
      }
    }
  };


  const sliderStatusClass = () => {
    return openItemName === name && statusSlider === "open"
      ? style.sliderOpen
      : style.sliderClose;
  };

  const renderPhaseBtn = (planTemplate) => {
    if (!planTemplate) return <div></div>;
    const isSelected = selectedPlanTemplate?.id === planTemplate.id;
    return (
      <div className={`${style.phaseBtn}`}>
        <div className={`no-link`}>
          <div className={`custom-height-similar`}>
            <div className={`clickable ${style.active} ${isSelected ? style.selected : ""}`}
              onClick={() => toggleDetails(planTemplate)}>
              {planTemplate.rehabPhaseName}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={`${style.PlanTemplateItem} ${sliderStatusClass()}`}>
      <div className={style.header} >
        <div className={style.name}>
          {name}
        </div>
        <div className={`${style.phasesContainer}`}>
          {/* This crap is used to show empty slots in the grid */}
          {[...Array(planTemplates.length).keys()].map((i) => renderPhaseBtn(planTemplates[i]))}
        </div>
      </div>
      {statusSlider == "open" &&
        <div className={style.slider}>
          <div className={style.planDuration}>
            {selectedPlanTemplate.translations.duration}: <div className={style.durationValue}>{selectedPlanTemplate.duration} min</div>
          </div>
          <div className={style.exerciseList}>
            {selectedPlanTemplate.exercises.map((exercise) => (
              <div key={exercise.id} className={style.exerciseItem}>
                <div className={style.exerciseImg}>
                  <img src={exercise.imageUrl} />
                </div>
                <div className={`auto-tooltip ${style.exerciseName}`}
                  data-toggle="tooltip"
                  title={exercise.name}>
                  {exercise.name}
                </div>
                <div className={style.exerciseDescription}>
                  {
                    [
                      exercise.repetitions ? `${exercise.repetitions} ${selectedPlanTemplate.translations.reps}` : null,
                      exercise.time ? `${exercise.time}"` : null,
                      exercise.sets ? `${exercise.sets} ${selectedPlanTemplate.translations.sets}` : null,
                    ].filter(e => e).join(" | ")
                  }
                </div>
              </div>
            ))}
          </div>
          {/* <div className={style.footer}></div> */}
        </div>
      }
    </div>
  );
}

PlanTemplateItem.propTypes = {};

PlanTemplateItem.defaultProps = {};

export default PlanTemplateItem;
